export default {
  SET_ACTIVITIES: (state, payload) => state.activities = payload,
  SET_MACRO_ACTIVITIES: (state, payload) => state.macroActivities = payload,
}